import React from 'react';
import {withStyles} from '@material-ui/core';
import SnackbarContent from '@material-ui/core/SnackbarContent';

import i18n from '../i18n';
import Layout from '../components/Layout';
import Toolbar from '../components/Toolbar/Toolbar';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import NotesList from '../components/Notes/NotesList';
import BuildingList from "../components/Building/BuildingList";

const Dashboard = ({classes, session, myNotes, buildings}) => {
    //let noteList = myNotes.data || myNotes;
    let constructionList = true;
    const user = window.__DATA__._user;

    return (
        <Layout>
            {!user.roleNames.length ? (
                <React.Fragment>
                    <Toolbar
                        disableGutters
                        title={i18n.get('dashboard.welcome')}
                    />
                    <div>
                        {i18n.get('dashboard.welcome_sentence',{name: user.name})}
                    </div>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Toolbar
                        disableGutters
                        title={i18n.get('dashboard.current_construction_projects')}
                    />

                    <div className={classes.flash}>
                        {session.status && (
                            <SnackbarContent
                                className={classes.message}
                                aria-describedby="client-snackbar"
                                message={(
                                    <span id="client-snackbar">
                            {session.status}
                        </span>
                                )}
                            />
                        )}
                    </div>

                    {constructionList && (
                        <BuildingList values={ {buildings: buildings} || {}} />
                    )}
                </React.Fragment>
            )}
        </Layout>
    );
};

const styles = theme => ({
    flash: {
        marginBottom: theme.spacing.unit * 3,
    },
    message: {
        maxWidth: '100%',
        backgroundColor: theme.palette.primary.main,
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(Dashboard);
